module.exports = __webpack_public_path__ + "img/02-01-img-01.a42bee15.png";